import * as Linkify from 'linkifyjs';

Linkify.options.defaults.defaultProtocol = 'https';

export {
	Linkify,
};
